import apiClient from './meta-client';

export interface CreateTransitionRequest {
    from_node_id: number;
    to_node_id: number;
    to_button_id?: number | null;
}

export interface UpdateTransitionRequest {
    to_node_id?: number;
    to_button_id?: number | null;
}

export interface TransitionResponse {
    id: number;
    funnel_id: number;
    from_node_id: number;
    to_node_id: number;
    to_button_id: number | null;
    created_at: string;
    updated_at: string;
}

export interface TransitionValidationResponse {
    is_valid: boolean;
    errors: string[];
}

// Criar transição
export const createTransition = async (
    data: CreateTransitionRequest
): Promise<TransitionResponse> => {
    const response = await apiClient.post<TransitionResponse>('/transitions', data);
    return response.data;
};

// Obter transição específica
export const getTransition = async (transitionId: number): Promise<TransitionResponse> => {
    const response = await apiClient.get<TransitionResponse>(`/transitions/${transitionId}`);
    return response.data;
};

// Listar transições do funil
export const getFunnelTransitions = async (funnelId: number): Promise<TransitionResponse[]> => {
    const response = await apiClient.get<TransitionResponse[]>(`/funnels/${funnelId}/transitions`);
    return response.data;
};

// Atualizar transição
export const updateTransition = async (
    transitionId: number,
    data: UpdateTransitionRequest
): Promise<TransitionResponse> => {
    const response = await apiClient.put<TransitionResponse>(`/transitions/${transitionId}`, data);
    return response.data;
};

// Deletar transição
export const deleteTransition = async (
    transitionId: number
): Promise<{ message: string; success: boolean }> => {
    const response = await apiClient.delete<{ message: string; success: boolean }>(
        `/transitions/${transitionId}`
    );
    return response.data;
};

// Validar transições do funil
export const validateFunnelTransitions = async (
    funnelId: number
): Promise<TransitionValidationResponse> => {
    const response = await apiClient.get<TransitionValidationResponse>(
        `/funnels/${funnelId}/transitions/validate`
    );
    return response.data;
};
